import React from 'react';
import { Banner, Body, Label, Stack } from '@qred/components-library';
import useTranslate from '~/hooks/useTranslate';
import useMarketConfig from '~/hooks/useMarketConfig';
import AccountNumberInput from './AccountNumberInput';
import PayoutAccountLabel from './PayoutAccountLabel';

const ManualAccountForm = () => {
  const translate = useTranslate();
  const { marketHasManualAccountHelperText } = useMarketConfig();

  return (
    <Stack spacing="xl">
      <Banner
        opened
        withCloseButton={false}
        state="neutral"
        message={
          <Stack spacing={'xs'}>
            <Label size={'lg'} data-record>
              {translate('OnboardingOffer.ManualVerificationTitle')}
            </Label>
            <Body size={'sm'} data-record>
              {translate('OnboardingOffer.ManualVerificationDescription')}
            </Body>
            <Body size={'sm'} data-record>
              {translate('OnboardingOffer.ManualVerificationTip')}
            </Body>
          </Stack>
        }
      />
      <Stack spacing="sm">
        <PayoutAccountLabel />
        <AccountNumberInput
          hint={
            marketHasManualAccountHelperText
              ? translate('OnboardingOffer.ManualAccountHelperText')
              : undefined
          }
        />
      </Stack>
    </Stack>
  );
};

export default ManualAccountForm;
